import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import App from "./App";
import Admin from "./Admin";
import Login from "./Login";
import { AuthProvider, useAuth } from "./auth";
import { CreditAlertProvider } from "./CreditAlert";
import { Loader2 } from "lucide-react";
import { PLATFORM, goToPlatformLogin, loadHelpWidget } from "./platform";

const Spinner = () => (
  <div className="flex min-h-screen items-center justify-center bg-heda-cream">
    <Loader2 size={28} className="animate-spin text-heda-gold" />
  </div>
);

function Protected({ children, adminContext = false }) {
  const { user, loading, exchangeError } = useAuth();
  // Under the platform, signing in happens there (unless its pass just failed).
  const toPlatform = PLATFORM && !loading && !user && !exchangeError;
  useEffect(() => {
    if (toPlatform) goToPlatformLogin();
  }, [toPlatform]);
  if (loading || toPlatform) return <Spinner />;
  if (!user) {
    return (
      <Login
        error={exchangeError}
        subtitle={
          adminContext ? "Sign in to view the gallery" : "Sign in to continue"
        }
      />
    );
  }
  return children;
}

loadHelpWidget();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
    <AuthProvider>
      <CreditAlertProvider>
        <Routes>
          <Route
            path="/"
            element={
              <Protected>
                <App />
              </Protected>
            }
          />
          <Route
            path="/admin"
            element={
              <Protected adminContext>
                <Admin />
              </Protected>
            }
          />
          {/* Any other address (old bookmark, typo): home, not a blank page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </CreditAlertProvider>
    </AuthProvider>
  </BrowserRouter>
);
